import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import DashboardPage from "../pages/dashboard/DashboardPage";
import BookingListPage from "../pages/bookings/BookingListPage";
import UserListPage from "../pages/users/UserListPage";
import LoginPage from "../pages/auth/LoginPage";
import Layout from "../components/layout/Layout";
import NotificationPage from "../pages/notifications/NotificationPage";
import ReportsPage from "../pages/reports/RepotsPage";
import PaymentsPage from "../pages/payments/PaymentPage";
import ServicesList from "../pages/services/ServicesList";

import { MESSAGES } from "../constants";

const isAuthenticated = () => {
  return !!localStorage.getItem("admin_token");
};

const AppRoutes = () => {
  const isAuth = isAuthenticated();

  return (
    <BrowserRouter>
      <Routes>
        {/* Default */}
        <Route
          path="/"
          element={
            isAuth ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Login */}
        <Route
          path="/login"
          element={
            isAuth ? <Navigate to="/dashboard" replace /> : <LoginPage />
          }
        />

        {/* 🔥 PROTECTED + LAYOUT */}
        <Route element={isAuth ? <Layout /> : <Navigate to="/login" replace />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/bookings" element={<BookingListPage />} />
          <Route path="/users" element={<UserListPage />} />
          <Route path="/notifications" element={<NotificationPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/services" element={<ServicesList />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<div>{MESSAGES.PAGE_NOT_FOUND}</div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
